import axios from "axios";
import { getSdk } from "../../services/sdkService";

export async function requestAdPostCall(URL, nonce, vid_d, vid, parms) {
  let env = process.env.NODE_ENV;
  env = window.location.href.includes("stg") ? "staging" : env;
  const envUrl =
    env === "development" || env === "staging"
      ? window.innerWidth >= 1280
        ? "https%3A%2F%2Flg-stg.aws.playco.com"
        : "https%3A%2F%2Flg-stg1280.aws.playco.com"
      : window.innerWidth >= 1280
      ? "https%3A%2F%2Flg.starzplay.com"
      : "https%3A%2F%2Flg1280.starzplay.com";
  try {
    let customConfig = {
      headers: {
        "Content-Type": "application/json"
      }
    };
    let session_params = {
      reportingMode: "SERVER",
      adsParams: {
        nonce: nonce,
        paln: nonce,
        ppid: localStorage.getItem("globalUserId"),
        ssid: "123456",
        is_lat: "0",
        npa: "0",
        idtype: "lg",
        ctv: "1",
        gdpr_consent: "true",
        url: envUrl,
        msid: "G15201003509",
        cmsid: "2644859",
        vid: vid ? vid : null,
        vid_d: vid_d ? vid_d.toString() : null,
        ...parms
      }
    };
    const apicall = await axios.post(URL, JSON.stringify(session_params), customConfig);
    const data = apicall.data;
    return data;
  } catch (errors) {
    console.log("error: ", errors);
    return null;
  }
}

export async function requestAdGetCall(URL) {
  try {
    if (isValidUrl(URL)) {
      const apicall = await axios.get(URL);
      const data = apicall.data;
      return data;
    } else return null;
  } catch (errors) {
    console.log(errors);
  }
}

export async function parseTrackerCallData(data) {
  let adJson = [];
  let adDetailJson = [];
  let skipUrls = [];
  let adbreaks = {};
  let adDetails = {};
  if (data && data.avails) {
    for (let i = 0; i < data.avails.length; i++) {
      let totalSectionAds = data.avails[i].ads ? data.avails[i].ads.length : 0;
      for (let j = 0; j < data.avails[i].ads.length; j++) {
        let clickThroughUrls = null;
        let ad = data.avails[i].ads[j];
        for (let beaconId in ad.trackingEvents) {
          let beacon = ad.trackingEvents[beaconId];
          const adUrl = beacon.eventType === "clickThrough" ? beacon.beaconUrls : null;
          if (adUrl) clickThroughUrls = adUrl;
          if (beacon.eventType == "skip") skipUrls = beacon.beaconUrls;
        }
        adDetails = {
          adId: ad.adId,
          adTitle: ad.adTitle,
          adNumber: j,
          adStartTime: parseFloat(ad.startTimeInSeconds.toFixed(2)),
          adDuration: parseFloat(ad.durationInSeconds.toFixed(2)),
          skipOffset: ad.skipOffset,
          skipUrls: skipUrls,
          clickThroughUrls: clickThroughUrls,
          creativeId: ad.creativeId
        };
        adDetailJson.push(adDetails);
        adDetails = {};
      }
      adbreaks = {
        adBreakStartTime: parseFloat(data.avails[i].startTimeInSeconds.toFixed(2)),
        totalAdBreakDuration: parseFloat(data.avails[i].durationInSeconds.toFixed(2)),
        totalAds: totalSectionAds,
        ads: adDetailJson
      };
      adDetailJson = [];
      adJson.push(adbreaks);
    }
  }
  return adJson;
}

// Video Commerce API Call
export async function getVideoCommerceData(content_id) {
  try {
    const sdk = await getSdk();
    const response = await sdk.analyticsManager.getVideoCommerceData({ content_id });
    const data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
}

export function timeToSeconds(timeString) {
  const [hours, minutes, seconds] = timeString.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

function isValidUrl(url) {
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
}

export function isValidTime(str) {
  const regex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
  return regex.test(str);
}
